import { IIndexable } from '../model/IIndexable';
import { RubroListData } from '../model/RubroListData';
import { rubroDataMapping } from './rubroDataMapping';

export function rubroListDataMapping(list: IIndexable) {
  return new RubroListData(list.map((rubro: IIndexable) => rubroDataMapping(rubro)));
}
